import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Navigation, Router } from '@angular/router';
import { LoadAddEditService } from 'src/app/services/load-add-edit.service';
import { Load } from '../model/load.model';

@Component({
  selector: 'app-load-add-edit',
  templateUrl: './load-add-edit.component.html',
  styleUrls: ['./load-add-edit.component.css']
})
export class LoadAddEditComponent implements OnInit {

  public selectedLoad: Load = new Load()
  isSubmitted = false;
  myForm: FormGroup;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private loadAddEditService: LoadAddEditService) {
    let token = this.route.snapshot.params.isEditOrAdd;

    if(token === 'true') {
      // this.selectedLoad = JSON.parse(localStorage.getItem('selectedLoad'));
      let nav: Navigation = this.router.getCurrentNavigation();
      this.selectedLoad = nav.extras.state.load;
    }
  }

  /**
   * Use cases
   * 1. Enable logon on button click
   * 2. patch a new form from child component
   * 3.
   */

  ngOnInit(): void {
   this.loadAddEditService.buildMyForm(this.selectedLoad);
   this.myForm = this.loadAddEditService.loadAddEditForm;
  }

  /**
   * Used to save load details.
   */
     public submitForm(form: FormGroup) {
      //save api....

      //this.router.navigate(['loaddetails/']);
      this.isSubmitted = true;
      console.log('Valid?',form.valid);
      console.log('Logon',form.value.logon);
      console.log('productName',form.value.productName);
      console.log('scac',form.value.scac);
      this.loadAddEditService.submitValue(form.value);
    }

}
